import styled from "styled-components";

export const Container = styled.div`
  height: ${(props) => props.height || "100vh"};
  width: 100%;
  -webkit-scroll-snap-align: ${(props) => props.scrollSnap || "center"};
  scroll-snap-align: ${(props) => props.scrollSnap || "center"};
  scroll-behavior: smooth;
  align-items: ${(props) => props.alignItems || "inherit"};
  display: ${(props) => props.display || "inherit"};
  justify-content: center;
  flex-direction: row;
  // @media only screen and (min-width: 768px) {
  //   display: flex;
  // }
  position: ${(props) => props.position || "inherit"};
  background: ${(props) => props.background || "inherit"};
  background-color: ${(props) => props.backgroundColor || "inherit"};
  padding: ${(props) => props.padding || "0px"};
`;
